import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfileVendor,
  CreateDeviceProfileVendorRequest,
} from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";
import type { CreateDeviceProfileVendorResponse } from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import VendorForm from "./VendorForm";
import deviceProfileStore from "../../stores/DeviceProfileStore";
import { useTitle } from "../helpers";

function CreateVendor() {
  useTitle("Network Server", "Device Profiles", "Vendors", "Add");
  const navigate = useNavigate();

  const onFinish = (vendor: DeviceProfileVendor) => {
    const req = new CreateDeviceProfileVendorRequest();
    req.setVendor(vendor);

    deviceProfileStore.createVendor(req, (resp: CreateDeviceProfileVendorResponse) => {
      navigate(`/device-profiles/vendors/${resp.getId()}/devices`);
    });
  };

  return (
    <Space orientation="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb
            items={[
              { title: "Network Server" },
              { title: "Device Profiles" },
              { title: <Link to="/device-profiles/vendors">Vendors</Link> },
              { title: "Add" },
            ]}
          />
        )}
        title="Add vendor"
      />
      <Card>
        <VendorForm initialValues={(() => { const v = new DeviceProfileVendor(); v.setPublished(true); return v; })()} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default CreateVendor;
